export default function CommentsSection() {
  const comments = [
    {
      name: '追剧达人小王',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20portrait%20avatar%2C%20warm%20lighting%2C%20friendly%20expression%2C%20simple%20dark%20background%2C%20professional%20headshot%20style%2C%20no%20text&width=80&height=80&seq=avatar-01&orientation=squarish',
      text: '用了极速影视大半年了，真的是追剧神器！播放速度比别的平台快太多了，画质也很清晰。最重要的是完全免费，不用开会员就能看全集，太良心了。',
      date: '2026-07-28',
    },
    {
      name: '电影爱好者老陈',
      avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20male%20portrait%20avatar%2C%20warm%20lighting%2C%20confident%20expression%2C%20simple%20dark%20background%2C%20professional%20headshot%20style%2C%20no%20text&width=80&height=80&seq=avatar-02&orientation=squarish',
      text: '作为一个看了二十年电影的老影迷，极速影视的片库真的让我惊喜。从老港片到最新好莱坞大片都有，而且秒开即播没广告，体验感满分。',
      date: '2026-07-25',
    },
    {
      name: '动漫迷小樱',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%20avatar%2C%20warm%20lighting%2C%20bright%20expression%2C%20simple%20dark%20background%2C%20professional%20headshot%20style%2C%20no%20text&width=80&height=80&seq=avatar-03&orientation=squarish',
      text: '动漫专区太强了！《咒术回战》《鬼灭之刃》都是同步更新，画质超清还没有水印。离线缓存功能也特别实用，地铁上也能追番。',
      date: '2026-07-22',
    },
  ];

  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            用户评价
          </h2>
          <p className="text-sm text-foreground-500">来自真实用户的观影反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((c, i) => (
            <div
              key={i}
              className="p-6 bg-background-50 rounded-xl border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 border-2 border-accent-500/30">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-100">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">{c.text}</p>
              <div className="flex items-center gap-1 mt-3">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}